const de = {
  brand: "Offertli",
  nav: {
    dashboard: "Übersicht",
    customers: "Kunden",
    requests: "Anfragen",
    offers: "Offerten",
    projects: "Projekte",
    invoices: "Rechnungen",
    catalog: "Inventar",
    organization: "Organisation",
    users: "Benutzer",
    settings: "Einstellungen",
    more: "Mehr",
    newRequest: "Neue Anfrage",
    notifications: "Mitteilungen",
    main: "Hauptnavigation",
  },
  userMenu: {
    label: "Benutzermenü",
    language: "Sprache",
    logout: "Abmelden",
  },
  theme: {
    label: "Erscheinungsbild",
    system: "System",
    light: "Hell",
    dark: "Dunkel",
  },
  locale: {
    en: "English",
    de: "Deutsch",
    fr: "Français",
    es: "Español",
  },
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    back: "Zurück",
    next: "Weiter",
    continue: "Fortfahren",
    submit: "Absenden",
    close: "Schliessen",
    loading: "Wird geladen…",
    retry: "Erneut versuchen",
    yes: "Ja",
    no: "Nein",
    optional: "optional",
    required: "Pflichtfeld",
    add: "Hinzufügen",
    remove: "Entfernen",
    edit: "Bearbeiten",
    delete: "Löschen",
    email: "E-Mail",
    password: "Passwort",
    firstName: "Vorname",
    lastName: "Nachname",
    phone: "Telefon",
    website: "Webseite",
    name: "Name",
    stepOf: "Schritt {{current}} von {{total}}",
  },
  validation: {
    required: "Dieses Feld ist erforderlich.",
    email: "Bitte eine gültige E-Mail-Adresse eingeben.",
    minLength: "Mindestens {{min}} Zeichen erforderlich.",
    maxLength: "Höchstens {{max}} Zeichen erlaubt.",
    passwordMin: "Das Passwort muss mindestens {{min}} Zeichen lang sein.",
    passwordMismatch: "Die Passwörter stimmen nicht überein.",
    iban: "Bitte eine gültige IBAN eingeben.",
    qrIbanRequired: "Für QR-Referenzen (QRR) ist eine QR-IBAN erforderlich.",
    termsRequired: "Bitte akzeptieren Sie die Bedingungen, um fortzufahren.",
    rateRange: "Der Satz muss zwischen 0 und 100 liegen.",
    invalidNumber: "Bitte eine gültige Zahl eingeben.",
    tokenRequired: "Bitte das Setup-Token eingeben.",
    minOneRate: "Mindestens ein Steuersatz ist erforderlich.",
    passwordLetter: "Das Passwort muss mindestens einen Buchstaben enthalten.",
    passwordNumber: "Das Passwort muss mindestens eine Zahl enthalten.",
    passwordPolicy:
      "Verwenden Sie mindestens 10 Zeichen, darunter einen Buchstaben und eine Zahl.",
    localeUnsupported: "Wählen Sie eine der unterstützten Sprachen aus.",
    invalidDate: "Bitte geben Sie ein gültiges Datum ein.",
    invalidTime: "Bitte geben Sie eine gültige Uhrzeit ein.",
    endAfterStart: "Die Endzeit muss nach der Startzeit liegen.",
    completeDateTime:
      "Geben Sie sowohl ein Datum als auch eine Uhrzeit im 24-Stunden-Format (HH:mm) ein.",
  },
  errors: {
    generic: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    invalidFields:
      "Prüfen Sie die markierten Felder und korrigieren Sie die Fehler.",
    network: "Der Server ist nicht erreichbar. Bitte Verbindung prüfen.",
    sessionExpired: "Ihre Sitzung ist abgelaufen. Bitte erneut anmelden.",
    forbidden: "Sie haben keine Berechtigung für diese Seite.",
    invalidCredentials: "E-Mail oder Passwort ist falsch.",
    tooManyAttempts: "Zu viele Versuche. Bitte später erneut versuchen.",
  },
  forbidden: {
    title: "Kein Zugriff",
    message:
      "Ihr Konto besitzt nicht die erforderliche Berechtigung für diese Seite.",
    backHome: "Zur Übersicht",
  },
  status: {
    draft: "Entwurf",
    submitted: "Eingereicht",
    in_process: "In Bearbeitung",
    processed: "Bearbeitet",
    ready: "Bereit",
    sent: "Versendet",
    accepted: "Angenommen",
    rejected: "Abgelehnt",
    declined: "Abgelehnt",
    planned: "Geplant",
    scheduled: "Terminiert",
    in_progress: "In Bearbeitung",
    on_hold: "Pausiert",
    completed: "Abgeschlossen",
    issued: "Ausgestellt",
    credited: "Gutgeschrieben",
    unpaid: "Unbezahlt",
    partially_paid: "Teilbezahlt",
    paid: "Bezahlt",
    overpaid: "Überbezahlt",
    overdue: "Überfällig",
    low: "Niedrig",
    normal: "Normal",
    high: "Hoch",
    invited: "Eingeladen",
    active: "Aktiv",
    suspended: "Gesperrt",
    deactivated: "Deaktiviert",
  },
  auth: {
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    login: {
      title: "Anmelden",
      subtitle: "Melden Sie sich bei Ihrem Offertli-Konto an.",
      email: "E-Mail",
      password: "Passwort",
      rememberMe: "Angemeldet bleiben",
      submit: "Anmelden",
      submitting: "Anmeldung läuft…",
      forgot: "Passwort vergessen?",
    },
    forgot: {
      title: "Passwort zurücksetzen",
      subtitle:
        "Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen.",
      submit: "Link senden",
      sentTitle: "Posteingang prüfen",
      sentMessage:
        "Falls ein Konto mit dieser E-Mail-Adresse existiert, erhalten Sie in Kürze einen Link zum Zurücksetzen des Passworts.",
      backToLogin: "Zurück zur Anmeldung",
    },
    reset: {
      title: "Neues Passwort wählen",
      subtitle: "Legen Sie ein neues Passwort für Ihr Konto fest.",
      newPassword: "Neues Passwort",
      confirmPassword: "Passwort bestätigen",
      submit: "Neues Passwort setzen",
      successTitle: "Passwort aktualisiert",
      successMessage:
        "Ihr Passwort wurde geändert. Sie können sich jetzt anmelden.",
      missingToken: "Dieser Link ist ungültig oder abgelaufen.",
      toLogin: "Weiter zur Anmeldung",
    },
  },
  invite: {
    title: "Einladung annehmen",
    subtitle:
      "Willkommen bei Offertli. Setzen Sie Ihr Passwort, um Ihr Konto zu aktivieren.",
    invitedAs: "Sie wurden eingeladen als",
    email: "E-Mail",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    acceptTerms:
      "Ich akzeptiere die Nutzungsbedingungen und den Datenschutzhinweis.",
    submit: "Konto aktivieren",
    invalidTitle: "Einladung ungültig",
    invalidMessage:
      "Dieser Einladungslink ist ungültig, abgelaufen oder wurde bereits verwendet.",
    toLogin: "Zur Anmeldung",
  },
  setup: {
    title: "Offertli einrichten",
    subtitle: "Konfigurieren Sie Ihr Unternehmen in wenigen Schritten.",
    alreadyDone: "Die Einrichtung ist bereits abgeschlossen.",
    steps: {
      credential: "Zugang",
      language: "Sprache",
      industry: "Branche",
      company: "Unternehmen",
      address: "Adresse",
      branding: "Erscheinungsbild",
      systemAdmin: "Systemadministrator",
      localization: "Lokalisierung",
      vat: "MWST",
      bank: "Bank & QR-Rechnung",
      numbering: "Nummerierung",
      review: "Überprüfen",
    },
    credential: {
      title: "Zugang prüfen",
      description:
        "Geben Sie das Setup-Token aus Ihrer Serverkonfiguration ein oder öffnen Sie den Einladungslink aus Ihrer E-Mail.",
      tokenLabel: "Setup-Token",
      tokenHint:
        "Das Token finden Sie in Ihrer Deployment-Umgebung (OFFERTLI_SETUP_TOKEN).",
      validate: "Token prüfen",
      validating: "Wird geprüft…",
      invalid:
        "Dieses Token ist ungültig oder die Einrichtung wurde bereits abgeschlossen.",
      inviteDetected: "Einladungslink erkannt",
      inviteValid: "Einladung für {{email}} bestätigt.",
      inviteInvalid: "Dieser Einladungslink ist ungültig oder abgelaufen.",
      useToken: "Stattdessen Setup-Token verwenden",
    },
    language: {
      title: "Oberflächensprache",
      description:
        "Wählen Sie die Sprache für diesen Assistenten und Ihre eigene Oberfläche.",
    },
    industry: {
      label: "Branche",
      description:
        "Wählen Sie die Branche, die am besten zu Ihrem Unternehmen passt. Wir bereiten passende Standardkategorien vor.",
      options: {
        landscaping: "Garten- und Landschaftsbau",
        general_services: "Allgemeine Dienstleistungen",
        construction: "Baugewerbe",
        cleaning: "Reinigung",
        other: "Andere",
      },
    },
    company: {
      title: "Unternehmensidentität",
      name: "Firmenname",
      tradingName: "Handelsname",
      vatNumber: "MWST- / UID-Nummer",
      website: "Webseite",
    },
    address: {
      title: "Adresse & Kontakt",
      line1: "Adresszeile 1",
      line2: "Adresszeile 2",
      postalCode: "PLZ",
      city: "Ort",
      canton: "Kanton / Region",
      country: "Land",
      email: "E-Mail Unternehmen",
      phone: "Telefon",
    },
    systemAdmin: {
      title: "Systemadministrator",
      description:
        "Legen Sie das Passwort für den integrierten Systemadministrator fest. Es wird kein Mitarbeiter- oder Benutzerkonto erstellt.",
      username: "Benutzername",
    },
    localization: {
      title: "Sprache, Zeitzone & Währung",
      locale: "Standardsprache",
      localeHint:
        "Wird für neue Benutzer und Dokumente verwendet, wenn keine Präferenz gesetzt ist.",
      timezone: "Zeitzone",
      currency: "Währung",
    },
    vat: {
      title: "MWST & Steuersätze",
      registered: "MWST-registriert",
      registeredHint:
        "Aktivieren, wenn Ihr Unternehmen mehrwertsteuerpflichtig ist.",
      rates: "Steuersätze",
      ratesHint: "Definieren Sie die MWST-Sätze für Offerten und Rechnungen.",
      rateName: "Bezeichnung",
      rateValue: "Satz (%)",
      isDefault: "Standard",
      addRate: "Satz hinzufügen",
      standardRate: "Normalsatz",
      noVat: "Keine MWST",
    },
    bank: {
      title: "Bank & QR-Rechnung",
      description: "Wird für Schweizer QR-Rechnungen verwendet.",
      iban: "IBAN",
      ibanHint: "Die IBAN, auf die Zahlungen erfolgen sollen.",
      qrIbanHint: "QRR-Referenzen erfordern eine QR-IBAN (QR-IID 30000–31999).",
      bankName: "Bank",
      referenceType: "Referenztyp",
      refNON: "Keine Referenz (NON)",
      refSCOR: "Creditor Reference (SCOR)",
      refQRR: "QR-Referenz (QRR)",
      paymentTermDays: "Zahlungsfrist (Tage)",
    },
    numbering: {
      title: "Nummerierung & Dokumentstandards",
      description:
        "Dokumentnummern werden automatisch vergeben. Präfixe und Formate können Sie später in den Einstellungen anpassen.",
      paymentTermDays: "Zahlungsfrist (Tage)",
      offerValidityDays: "Offertgültigkeit (Tage)",
      previewTitle: "Standard-Nummernformate",
      customer: "Kunde",
      request: "Anfrage",
      offer: "Offerte",
      project: "Projekt",
      invoice: "Rechnung",
    },
    review: {
      title: "Überprüfen & abschliessen",
      description:
        "Prüfen Sie Ihre Konfiguration, bevor Sie die Einrichtung abschliessen.",
      companySection: "Unternehmen",
      systemAdminSection: "Systemadministrator",
      localizationSection: "Lokalisierung",
      billingSection: "Abrechnung",
      documentsSection: "Dokumente",
      complete: "Einrichtung abschliessen",
      completing: "Wird abgeschlossen…",
      failed:
        "Die Einrichtung konnte nicht abgeschlossen werden. Bitte prüfen Sie Ihre Angaben.",
    },
  },
  dashboard: {
    title: "Übersicht",
    welcome: "Willkommen zurück, {{name}}.",
    placeholderTitle: "Ihre Übersicht wird vorbereitet",
    placeholderMessage:
      "Widgets für offene Anfragen, Offerten und Rechnungen erscheinen hier in der nächsten Iteration.",
  },
  notifications: {
    title: "Mitteilungen",
    empty: "Keine neuen Mitteilungen",
  },
  notFound: {
    title: "Seite nicht gefunden",
    message: "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    backHome: "Zur Übersicht",
  },
  offline: {
    title: "Sie sind offline",
    message:
      "Offertli benötigt eine Verbindung zum Server. Bitte prüfen Sie Ihr Netzwerk.",
    retry: "Erneut versuchen",
  },
} as const;

export default de;
